import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {Notification} from "src/app/infrastructure/moovement-api/models/notification";

@Injectable({
  providedIn: 'root'
})
export class NotificationApiClient extends MoovementApiClient {



  getNotifications(since: Date): Observable<Notification[]> {
    return this.httpClient.get<Notification[]>(`${this.baseUrl}/api/notification/list?from=${since.toISOString()}`);
  }

  dismissNotification(notification: Notification): Observable<Notification> {
    notification.dismissalTime = new Date().toISOString();
    return this.httpClient.post<Notification>(`${this.baseUrl}/api/notification`, notification);
  }
}
